import { TextInput } from '@mantine/core';
import classNames from 'theme/components/Inputs/TextInput/TextInput.module.css';

export default TextInput.extend({
  classNames,
  defaultProps: {
    size: 'md',
  },
});
